import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

export interface ProjectAppointment {
  id?: number;
  projectId?: number;
  startDate: string; // yyyy-mm-dd
  endDate?: string; // yyyy-mm-dd
  time?: string; // optional HH:mm
  title: string;
  description?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProjectAppointmentService {
  // base API path (no environment variable present in this project), use /api as root


  private baseUrl = environment.apiUrl +'ProjectAppointments';// Replace with your API endpoint
 
 

  constructor(private http: HttpClient) {}

  // GET: api/ProjectAppointments
  getAll(): Observable<ProjectAppointment[]> {
    return this.http.get<ProjectAppointment[]>(`${this.baseUrl}`);
  }

  // GET: api/ProjectAppointments/5
  getById(id: number): Observable<ProjectAppointment> {
    return this.http.get<ProjectAppointment>(`${this.baseUrl}/${id}`);
  }

  // GET: api/ProjectAppointments/GetProjectAppointmentsByProjectID?projectid=5
  getByProjectId(projectId: number): Observable<ProjectAppointment[]> {
    return this.http.get<ProjectAppointment[]>(`${this.baseUrl}/GetProjectAppointmentsByProjectID?projectid=${projectId}`);
  }

  // PUT: api/ProjectAppointments/5
  update(id: number, appointment: ProjectAppointment): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}`, appointment);
  }

  // POST: api/ProjectAppointments
  create(appointment: ProjectAppointment): Observable<ProjectAppointment> {
    return this.http.post<ProjectAppointment>(`${this.baseUrl}`, appointment);
  }

  // DELETE: api/ProjectAppointments/5
  delete(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }
}
